import { Controller } from '@hotwired/stimulus'
import { toPng } from 'html-to-image'

export default class extends Controller {
  static targets = [
    'currentColor',
    'currentBackColor',
    'palette',
    'preview',
    'previewPixel',
    'grid',
    'gridPixel',
    'text',
    'textPreview',
    'name',
    'namePreview',
    'penButton',
    'undoButton',
    'redoButton',
    'submitButton',
    'imageData',
    'advancedButton',
    'advanced',
    'step',
    'nameNextButton',
    'textNextButton',
    'nameCount',
    'textCount',
    'resetButton',
    'resetConfirm',
    'canvas',
    'submission'
  ]
  static values = {
    drawing: { type: Boolean, default: false },
    backDrawing: { type: Boolean, default: false },
    color: { type: String, default: '1' },
    backColor: { type: String, default: '0' },
    pen: { type: Number, default: 1 },
    image: { type: String, default: '0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000' },
    step: { type: Number, default: 0 },
    done: { type: Boolean, default: false }
  }

  connect() {
    document.querySelector('#soul').classList.remove('hidden')
    this.colors = ['0', 'r', 't', 'o', 'b', '1', 'p', 'g', 'y']
    this.colorClasses = this.colors.map(c => `bg-soul-${c}`)
    this.colorMap = {
      '0': '#000000',
      '1': '#FFFFFF',
      'r': '#FF0000',
      't': '#42FCFF',
      'o': '#FCA600',
      'b': '#003CFF',
      'p': '#D535D9',
      'g': '#00C000',
      'y': '#FFFF00'
    }
    this.colorNames = {
      '0': 'Black',
      '1': 'White',
      'r': 'Red',
      't': 'Light Blue',
      'o': 'Orange',
      'b': 'Dark Blue',
      'p': 'Purple',
      'g': 'Green',
      'y': 'Yellow'
    }

    // Load backup, if it exists and is valid
    let hasName = false
    if (localStorage.getItem('submit-name') !== null) {
      hasName = true
      this.namePreviewTarget.innerHTML = localStorage.getItem('submit-name')
    }
    let hasImage = false
    if (localStorage.getItem('submit-image') !== null && this.checkImageData(localStorage.getItem('submit-image'))) {
      hasImage = true
      this.imageValue = localStorage.getItem('submit-image')
    }
    let hasText = false
    if (localStorage.getItem('submit-text') !== null) {
      hasText = true
      this.textPreviewTarget.innerHTML = localStorage.getItem('submit-text')
    }
    if (localStorage.getItem('submit-done') !== null || (hasName && hasImage && hasText)) {
      this.submissionTarget.classList.remove('hidden')
    }
  }

  imageValueChanged() {
    for (const canvas of this.canvasTargets) {
      this.updateCanvas(canvas, this.imageValue)
    }
  }

  checkImageData(data) {
    return /^[0rtob1pgy]{2500}$/.test(data)
  }

  imageToPng(e) {
    if (this.checkImageData(this.imageValue)) {
      const button = e.target
      button.setAttribute('disabled', true)
      button.innerHTML = '<span class="inline-block animate-spin">◡</span>'
      toPng(document.querySelector(e.params.element), { pixelRatio: 2 })
      .then((dataUrl) => {
        const link = document.createElement('a')
        link.classList.add('hidden')
        link.href = dataUrl
        link.download = 'you.png'
        if (this.nameTarget.value.length > 0) {
          link.download = `${this.nameTarget.value}_${e.params.filename}.png`
        }
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
      setTimeout(function() {
        button.removeAttribute('disabled')
        button.innerHTML = e.params.filename
      }, 3000)
    } else {
      console.log('Malformed image, cannnot save')
    }
  }

  updateCanvas(canvas, image) {
    const ctx = canvas.getContext('2d')    
    const gridSize = 50
    const pixelSize = canvas.width / gridSize
    const colorMap = {
      '0': '#000000',
      '1': '#FFFFFF',
      'r': '#FF0000',
      't': '#42FCFF',
      'o': '#FCA600',
      'b': '#003CFF',
      'p': '#D535D9',
      'g': '#00C000',
      'y': '#FFFF00'
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height)

    for (let y = 0; y < gridSize; y++) {
      for (let x = 0; x < gridSize; x++) {
        const index = y * gridSize + x
        const char = image[index]

        const color = colorMap[char] || '#000000'
        ctx.fillStyle = color
        ctx.fillRect(x * pixelSize, y * pixelSize, pixelSize, pixelSize)
      }
    }
  }
}
